// @flow
import * as React from 'react';
import styled from 'styled-components';
import type { ActionType, ActionSubType } from 'api/volops';
import type { OrgType } from 'api/orgs';
import {
  LISTING_TYPE_HUMAN_NAME_MAP_TITLE,
  ACTION_TYPE,
  ACTION_SUB_TYPE,
  ORG_TYPES
} from 'utils/constants';
import { retinaBackgroundImage } from 'utils/style';
import Box from 'components/Box';
import Tooltip from 'components/Tooltip';
import { HeadingSmall } from 'components/Text';
import JobIcon from 'job.svg';
import VolopIcon from 'volop.svg';
import OrgIcon from 'org.svg';
import GroupIcon from 'group.svg';
import { colors } from '../theme';

const mapOrgTypeToTitle = (orgType: OrgType) => {
  const match = ORG_TYPES.find(org => org.id === orgType);
  return match ? match.name : LISTING_TYPE_HUMAN_NAME_MAP_TITLE.ORG;
};

const IdealistDayEventIcon = styled.div`
  ${retinaBackgroundImage('/static/images/i-days-icon.png')};
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  width: 19px;
  height: 19px;
`;

const getListingIcon = (type: string) => {
  switch (type) {
    case 'JOB':
    case 'GRAD_PROGRAM':
    case 'INTERNSHIP':
      return <JobIcon height="19" width="21" />;
    case 'VOLOP':
    case 'IMPORTED':
      return <VolopIcon height="19" width="13" />;
    case 'ORG':
      return <OrgIcon height="19" width="19" />;
    case 'GROUP':
      return <GroupIcon height="19" width="19" />;
    case 'IDEALIST_DAY_EVENT':
      return <IdealistDayEventIcon />;
    default:
      throw new Error('Invalid listing type');
  }
};

const ListingTypeLabel = ({
  listingType,
  actionType,
  actionSubType,
  orgType
}: {
  listingType: string,
  actionType?: ?ActionType,
  actionSubType?: ?ActionSubType,
  orgType?: OrgType
}) => {
  const actionTypeObject = ACTION_TYPE.find(({ id }) => actionType === id);
  const actionSubTypeObject = ACTION_SUB_TYPE.find(
    ({ id }) => actionSubType === id
  );
  return (
    <Box display="flex" alignItems="center">
      <Box mr="8px">{getListingIcon(listingType)}</Box>
      <HeadingSmall my={0} color={colors.battleshipGrey}>
        {['VOLOP', 'IMPORTED'].includes(listingType) && actionTypeObject
          ? `${actionTypeObject.name}${
              actionSubTypeObject ? `: ${actionSubTypeObject.name}` : ''
            }`
          : orgType
          ? mapOrgTypeToTitle(orgType)
          : LISTING_TYPE_HUMAN_NAME_MAP_TITLE[listingType]}
      </HeadingSmall>
      {orgType && orgType === 'CORPORATION' && (
        <Box ml="4px" mt="-1px">
          <Tooltip>
            {/* TRANSLATORS: Tooltip next to 'Business' label in org profile */ getText(
              `Social enterprises and approved for-profit companies are allowed to post jobs on Idealist that adhere to our guidelines.`
            )}
          </Tooltip>
        </Box>
      )}
    </Box>
  );
};

export default ListingTypeLabel;
